import React from "react";
import ClerkIncrementsButtonsGrid from "./ClerkIncrementsButtonsGrid";
import ClerkRoundStopButtonsGroup from "./ClerkRoundStopButtonsGroup";
import ClerkBiddingEditableNumericDisplayRowCmp from "./ClerkBiddingEditableNumericDisplayRowCmp";
import NumberDisplay from "../NumberDisplay";
import {BidReviseTypeEnum} from "@nextlot/core/webcast/data/WebcastDataDomain";
import {Participant} from "@nextlot/core/webcast/data/data_types_definitions";
import {TaggedLogger} from "@nextlot/core/utilities";
import {AuctionsManager, DataStore} from "@nextlot/core/webcast";
import {useAppSelector} from "@nextlot/core/webcast/hooks";
import {ClerkPlaceFloorAndOnlineBidButtonsStack} from "./ClerkPlaceFloorAndOnlineBidButtonsStack";


const _logger = TaggedLogger.get('ClerkRoundBiddingWithBidsReceivedCmp');



export default function ClerkRoundBiddingWithBidsReceivedCmp() {
    const myUserId = AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.participantId;

    const currentRoundId = useAppSelector((state) => state.activeWebcast.webcastCurrentRoundBidding.roundId);
    const askingBidValue = useAppSelector((state) => state.activeWebcast.webcastCurrentRoundBidding.askingBidValue);
    const bidIncrement = useAppSelector((state) => state.activeWebcast.webcastCurrentRoundBidding.bidIncrement);
    const highestBid = useAppSelector((state) => state.activeWebcast.webcastCurrentRoundBidding.highestBid);
    const participantsByUserId = useAppSelector((state) => state.activeWebcast.webcastParticipants.mapByUserId);



    const sendAskingBidUpdateMessage = (centsValue:number) => {
        AuctionsManager.currentWebcastAuctionHandler.controller.sendAskingBidUpdate(currentRoundId, centsValue);
    }


    const handleIncrementButtonClick = (centsValue:number) => {
        const newCentsValue = Math.max(1, highestBid.value + centsValue); // avoid 0 or negative values
        sendAskingBidUpdateMessage(newCentsValue);
    };



    const handleValidateAndSubmitNewValue_AskBid = (valueCents:number):string|null => {
        if (valueCents <= highestBid.value) {
            return 'Must be greater than highest bid'
        }

        if (valueCents === askingBidValue) {
            return 'Must be different then current asking bid'
        }

        sendAskingBidUpdateMessage(valueCents);

        // if validation ok, return null
        return null;
    };



    const handleValidateAndSubmitNewValue_Increment = (valueCents:number):string|null => {
        sendAskingBidUpdateMessage(highestBid.value + valueCents);
        // if validation ok, return null
        return null;
    };


    const handleClick_BidReviseOverride = () => {
        AuctionsManager.currentWebcastAuctionHandler.controller.sendBidRevise(currentRoundId, BidReviseTypeEnum.OVERRIDE_BY_FLOOR, highestBid.value);
    };

    const handleClick_BidReviseReverse = () => {
        AuctionsManager.currentWebcastAuctionHandler.controller.sendBidRevise(currentRoundId, BidReviseTypeEnum.REVERSE, highestBid.value);
    };



    const highestBidIsInternet = highestBid && highestBid.userId !== myUserId;

    const highestBidParticipant:Participant = participantsByUserId.get(highestBid.userId);
    const highestBidParticipantPersonName:string = highestBidParticipant ? highestBidParticipant.bidderPersonName : null;

    return (
        <div className="w-100 d-flex flex-column">

            <ClerkRoundStopButtonsGroup
                currentRoundId={currentRoundId}
                currentRoundHighestBid={highestBid}
            />

            <div className="ps-2 pt-2 d-flex justify-content-between align-items-start">


                <div className="clerk-bidding-values-container">

                    <div className={`bidding-values__row-highest-bid ${highestBid.userId !== myUserId ? 'row--internet-bidder' : ''}`}>
                        <div className="row__label">Highest:</div>
                        <div className="row__content">
                            <NumberDisplay valueCents={highestBid.value} allowZero={false} />
                            <div className="bidder-display"> {highestBid.bidderDisplay}</div>
                            <div className="small text-body-secondary">{highestBidParticipantPersonName}</div>
                        </div>
                    </div>



                    <ClerkBiddingEditableNumericDisplayRowCmp
                        label={'Asking:'}
                        valueCents={askingBidValue}
                        textForEmptyValue={'-'}
                        validateAndSubmitNewValueCents={handleValidateAndSubmitNewValue_AskBid}
                        componentClassName={'bidding-values__row-asking-bid-value'}
                    />



                    <ClerkBiddingEditableNumericDisplayRowCmp
                        label={'Increment:'}
                        valueCents={bidIncrement}
                        textForEmptyValue={'-'}
                        validateAndSubmitNewValueCents={handleValidateAndSubmitNewValue_Increment}
                        componentClassName={'bidding-values__row-asking-bid-increment'}
                    />

                </div>


                {
                    highestBid
                    &&
                    <div className="mx-3 pt-3 d-flex flex-column justify-content-around align-items-center">
                        <button className="btn btn-info" type="button" onClick={handleClick_BidReviseOverride} disabled={!highestBidIsInternet}>Override</button>
                        <div>&nbsp;</div>
                        <button className="btn btn-info" type="button" onClick={handleClick_BidReviseReverse}>Reverse</button>
                    </div>
                }

                <ClerkPlaceFloorAndOnlineBidButtonsStack />
            </div>


            <ClerkIncrementsButtonsGrid
                onButtonClick={handleIncrementButtonClick}
                valuesList={DataStore.config.default_clerk_increments}
                valuesSign={1}
                currentValue={bidIncrement}
            />

        </div>
    )
}





